(ns manage.adset.hooks
  (:require [cljs-bean.core :refer [->clj]]
            [common.flags :refer [use-flag]]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as q]
            [common.util :refer [spread-obj]]
            [manage.ad-variant.data :as variant-data]
            [mate.core :as mc]
            [uix.core :refer [defhook] :as uix]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-adset []
  (let [{:keys [adset-id]} (use-subscribe [:url-context])
        {adset :data} (use-query (q/adset-query {:adset-id adset-id}))]
    adset))

(defhook use-auto-approved? []
  (let [adset (use-adset)]
    (:autoApproveAdVariants adset)))

(defhook use-synced-with-hogarth? []
  (let [auto-approved? (use-auto-approved?)
        assemble-integration? (use-flag :production-studio-adsets)]
    (and auto-approved? assemble-integration?)))

(defhook use-channel []
  (let [adset (use-adset)]
    (:channel adset)))

(defhook use-adset-formats []
  (let [adset (use-adset)]
    (uix/use-memo
     #(->> adset
           :adBuilders
           (filter :active)
           (mapv (fn [ad-builder]
                   {:ad-type (-> ad-builder :urn variant-data/ad-builder-urn->ad-type)
                    :width (-> ad-builder :ad-formats first :width)
                    :height (-> ad-builder :ad-formats first :height)})))
     [adset])))

(defhook use-can-delete-adset? []
  (let [{:keys [workflow]} (use-adset)
        contains-published? (use-subscribe [:resource.content-function-version/contains-version? "published"])
        ad-variants-workflow? (= workflow "ad-variants")]
    (and (not contains-published?)
         (not ad-variants-workflow?))))

(defhook use-is-social-adset? []
  (let [{:keys [channel]} (use-adset)]
    (contains? #{"meta" "tiktok"} channel)))

(defn adset-id->adset-select [^js data]
  (->> (->clj data)
       (mc/index-by :id)))

(defhook use-adset-id->adset [{:keys [adset-id]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])

        {adset-id->adset-name :data} (use-query (spread-obj (q/adsets-query {:advertiser-id advertiser-id})
                                                            #js {:select adset-id->adset-select}))]
    (when (seq adset-id->adset-name)
      (adset-id->adset-name adset-id))))
